import { esc, fmtMoney } from "../ui/format.js";

/**
 * The org chart, part of the game's chart kit (2.7: moved here from ui/charts.js with the old canvas radar gone).
 */
// ---------------------------------------------------------------- SVG Org Chart
// A real interactive tree built from live org-chart data: root = company,
// one branch per department, one leaf per seniority level sized by headcount.
function renderOrgChartSVG(deptGroups, morale) {
  const depts = Object.entries(deptGroups);
  if (!depts.length) return `<p style="color:var(--text-mid); padding:10px;">No org chart data yet.</p>`;

  const leafW = 128, leafH = 46, deptGapX = 26, levelGapY = 64, topPad = 40;
  const deptWidths = depts.map(([, levels]) => levels.length * (leafW + 10) - 10);
  const totalW = deptWidths.reduce((a, b) => a + b, 0) + deptGapX * (depts.length - 1);
  const width = Math.max(totalW + 60, 420);
  const height = topPad + levelGapY + leafH + 20;
  const moraleColor = morale >= 70 ? "#34d399" : morale >= 45 ? "#fbbf24" : "#fb7185";

  let x = 30;
  const deptCenters = [];
  let leaves = "";
  depts.forEach(([dept, levels], di) => {
    const dw = deptWidths[di];
    const centerX = x + dw / 2;
    deptCenters.push({ dept, centerX, x, dw });
    levels.forEach((l, li) => {
      const lx = x + li * (leafW + 10);
      const ly = topPad + levelGapY;
      const intensity = Math.min(1, l.headcount / Math.max(1, Math.max(...levels.map((v) => v.headcount))));
      leaves += `
        <line x1="${centerX}" y1="${topPad + 18}" x2="${lx + leafW / 2}" y2="${ly}" stroke="var(--glass-border, rgba(140,170,255,0.25))" stroke-width="1.5"/>
        <g transform="translate(${lx},${ly})">
          <rect width="${leafW}" height="${leafH}" rx="8" fill="rgba(126,232,250,${0.05 + intensity * 0.12})" stroke="rgba(126,232,250,0.35)" stroke-width="1"/>
          <text x="10" y="17" font-family="IBM Plex Mono, monospace" font-size="9.5" fill="#a8b3d6" text-transform="uppercase">${esc(l.level)}</text>
          <text x="10" y="34" font-family="Inter, sans-serif" font-size="13" font-weight="700" fill="#eef2ff">${l.headcount.toLocaleString("en-US")}</text>
          <text x="${leafW - 8}" y="34" text-anchor="end" font-family="IBM Plex Mono, monospace" font-size="9.5" fill="#6b7495">${fmtMoney(l.annual_cost)}</text>
        </g>`;
    });
    x += dw + deptGapX;
  });

  const deptLabels = deptCenters.map((d) => `
    <g transform="translate(${d.centerX},${topPad})">
      <circle r="4" fill="${moraleColor}"/>
      <text x="0" y="-8" text-anchor="middle" font-family="Playfair Display, serif" font-weight="700" font-size="12.5" fill="#eef2ff">${esc(d.dept)}</text>
    </g>`).join("");

  const rootX = width / 2;
  const rootLines = deptCenters.map((d) => `<line x1="${rootX}" y1="14" x2="${d.centerX}" y2="${topPad - 6}" stroke="var(--glass-border, rgba(140,170,255,0.25))" stroke-width="1.5"/>`).join("");

  return `
    <svg viewBox="0 0 ${width} ${height}" width="${width}" height="${height}" style="display:block; margin:0 auto;">
      <circle cx="${rootX}" cy="10" r="6" fill="url(#orgRootGrad)"/>
      <defs>
        <radialGradient id="orgRootGrad"><stop offset="0%" stop-color="#a78bfa"/><stop offset="100%" stop-color="#7ee8fa"/></radialGradient>
      </defs>
      ${rootLines}
      ${deptLabels}
      ${leaves}
    </svg>
  `;
}

export { renderOrgChartSVG };
